import React, { memo, useRef } from 'react'
import dayjs from 'dayjs'
import { css } from '@emotion/css'
import { Input } from '@mantine/core'
import { DateRangePicker } from '@mantine/dates'
import { IconCalendarEvent } from '@tabler/icons'
import tw from 'twin.macro'
import { onPressEnter } from './utils'

const Search = ({ onSearch }) => {
  const filterRef = useRef({})
  const onDateRangeChange = ([begin, end]) => {
    if (begin && end) {
      filterRef.current.begin = dayjs(begin).format('YYYY-MM-DD HH:mm:ss')
      filterRef.current.end = dayjs(end)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss')
      onSearch(filterRef.current)
    }

    if (!begin && !end) {
      delete filterRef.current.begin
      delete filterRef.current.end
      onSearch(filterRef.current)
    }
  }

  const onKeywordChange = (e) => {
    filterRef.current.title = e.target.value
  }

  const onKeywordSearch = () => {
    onSearch(filterRef.current)
  }

  return (
    <div className="flex gap-4">
      <Input
        className={css`
          ${tw`w-32`}
          .mantine-Input-input {
            height: 32px;
            min-height: 32px;
            line-height: 30px;
          }
        `}
        placeholder="请输入关键字"
        onChange={onKeywordChange}
        onKeyDown={onPressEnter(onKeywordSearch)}
      />
      <DateRangePicker
        className={css`
          ${tw`w-64`}
          .mantine-DateRangePicker-input {
            height: 32px;
            min-height: 32px;
            line-height: 30px;
          }
        `}
        placeholder="请选择日期范围"
        rightSection={
          <IconCalendarEvent size={14} color="rgba(0, 0, 0, 0.25)" />
        }
        onChange={onDateRangeChange}
        inputFormat="YYYY-MM-DD"
        labelFormat="YYYY-MM"
      />
    </div>
  )
}

export default memo(Search)
